module.exports = __webpack_public_path__ + "static/media/reading-boomer.20e6a9ac.png";